import { render } from "./blacklist.vue?vue&type=template&id=11a58016&scoped=true"
import script from "./blacklist.vue?vue&type=script&lang=js"
export * from "./blacklist.vue?vue&type=script&lang=js"

import "./blacklist.vue?vue&type=style&index=0&id=11a58016&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a58016"]])

export default __exports__